package com.tovtalk.data.repository

import com.russhwolf.settings.Settings
import com.tovtalk.domain.repository.RecentSearchesRepository

private const val KEY_RECENT_SEARCHES = "recent_searches"
private const val MAX_RECENT_SEARCHES = 5
private const val DELIMITER = "\u001E"

/**
 * Recent searches – stored locally via Settings (SharedPreferences / UserDefaults).
 * No server sync. Limit 10 items, dedupe, insert at head.
 */
class RecentSearchesRepositoryImpl(
    private val settings: Settings
) : RecentSearchesRepository {

    override fun getRecentSearches(): List<String> {
        val raw = settings.getStringOrNull(KEY_RECENT_SEARCHES) ?: return emptyList()
        return raw.split(DELIMITER).map { it.trim() }.filter { it.isNotBlank() }
    }

    override fun addRecentSearch(query: String) {
        val trimmed = query.trim()
        if (trimmed.isBlank()) return
        val current = getRecentSearches()
        val updated = listOf(trimmed) + current.filter { it != trimmed }.take(MAX_RECENT_SEARCHES - 1)
        settings.putString(KEY_RECENT_SEARCHES, updated.joinToString(DELIMITER))
    }

    override fun clearRecentSearches() {
        settings.remove(KEY_RECENT_SEARCHES)
    }
}
